<template>
    <div class="container">
        <div class="mt-card-auth">
            <div class="card">
                <div class="card-body">
                    <div class="title text-center">
                        <div class="main-title">Abdi<span class="text-primary">Social</span></div>
                        <div class="sub-title mt-1">Reset Password Akun</div>
                    </div>

                    <div class="mt-4">
                        <div class="alert small" :class="error.resetPassword == 'not-error' ? 'alert-success' : 'alert-danger'" v-if="error.resetPassword">
                            <template v-if="error.resetPassword == 'error'">Terjadi kesalaham, silahkan coba lagi.</template>
                            <template v-else-if="error.resetPassword == 'not-found-email'">Email tidak ditemukan.</template>
                            <template v-else-if="error.resetPassword == 'not-error'">Berhasil, silahkan cek email anda</template>
                        </div>

                        <div class="form-group">
                            <vs-input v-model="form.email" placeholder="Email" type="email">
                                <template #icon>
                                    <box-icon name="mail-send"></box-icon>
                                </template>
                            </vs-input>
                        </div>

                        <div class="mt-4">
                            <vs-button block @click="resetPassword()" :loading="loading.resetPassword">Kirim</vs-button>
                            <div class="mt-2">
                                <vs-button block border @click="actionTo('login')" :loading="loading.resetPassword">Kembali ke Login</vs-button>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>
import firebase from 'firebase';

export default {
    data() {
        return {
            form: {
                email: '',
            },
            loading: {
                resetPassword: false,
            },
            error: {
                resetPassword: '',
            }
        }
    },
    methods: {
        actionTo(url) {
            this.$router.push({ path: url });
        },
        resetPassword() {
            if(this.form.email) {
                this.loading.resetPassword = true;
                this.error.resetPassword = '';

                firebase.auth().sendPasswordResetEmail(this.form.email).then(() => {
                    this.error.resetPassword = 'not-error';
                    this.loading.resetPassword = false;
                }).catch(err => {
                    if(err.code == 'auth/user-not-found') {
                        this.error.resetPassword = 'not-found-email';
                    } else {
                        this.error.resetPassword = 'error';
                    }

                    this.loading.resetPassword = false;
                })
            }
        }
    }
}
</script>

<style scoped>
@import '../../styles/auth.css';
</style>